module.exports = __webpack_public_path__ + "static/media/banner_cardMatka-half.74d615bf.png";